var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2389 25.0935C18.9855 25.0935 18.7322 25.0002 18.5322 24.8002C18.1455 24.4135 18.1455 23.7735 18.5322 23.3868L25.9189 16.0002L18.5322 8.61349C18.1455 8.22682 18.1455 7.58682 18.5322 7.20016C18.9189 6.81349 19.5589 6.81349 19.9455 7.20016L28.0389 15.2935C28.4255 15.6802 28.4255 16.3202 28.0389 16.7068L19.9455 24.8002C19.7455 25.0002 19.4922 25.0935 19.2389 25.0935Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.1041 17H4.66406C4.1174 17 3.66406 16.5467 3.66406 16C3.66406 15.4533 4.1174 15 4.66406 15H27.1041C27.6507 15 28.1041 15.4533 28.1041 16C28.1041 16.5467 27.6507 17 27.1041 17Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2);
export default __webpack_public_path__ + "static/media/arrow_right2.d0ff79b8f2e3d23215393f5616b4987a.svg";
export { ForwardRef as ReactComponent };